export default {
  data: () => ({
    rawData:      null,

    canvasForms:  null,

    header:       null,
    table:        null,
    progress:     null,
    columns:      null,
    keys:         null,
    filters:      null,
  }),




  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },
}